// VehTypeInfoView.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { DialogContent, DialogActions, Button, } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { AppStyle, AppWord } from '../../value/AppConst';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { VzmPrint } from '../../common/VzmStyled';
import { VehTypeInfoDictionary, RentTypes } from './VehTypeInfoDict';
import DraggableViewer from '../../common/DraggableViewer';
import { useAuthorizationCheck } from '../../api/app-hook';

// background color in gradient style (light gray to white, then light gray)
const ViewContainer = styled(Box)({
    marginTop: 10
});

const InputMap = VehTypeInfoDictionary.inputMap;

/**
 * 차종 정보 상세 보기
 */
export default function VehTypeInfoView({
    open,
    item,
    onRequestEdit,
    onClose
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();

    if(!open || !item) return null;

    const canEdit = checkAuth(authTableTree.tree.pr_veh_type_info_edit);

    return(
        <DraggableViewer open={open} onClose={onClose} maxWidth='lg'
            title={
                <>
                <LocalShippingIcon fontSize={AppWord.LARGE} style={{color:'white', marginRight:15}}/>
                차종: {item.vehTypeName}
                </>
            }
        >
            <DialogContent>
                <ViewContainer>
                    <VzmPrint label={InputMap.vehTypeName.label} value={item.vehTypeName} marginBottom={8} />
                    <VzmPrint label='신선/상온' value={item.freshCargo ? '신선차량':'상온차량'} marginBottom={8} />
                    {
                        item.freshCargo ?
                        <VzmPrint label="온도 제한" value={`${item.minTemp || '최소제한없음'} ~ ${item.maxTemp || '최대제한없음'}`} marginBottom={8} />
                        : null
                    }
                    <VzmPrint label={InputMap.cargoUnit.label} value={item.cargoUnit} marginBottom={8} />
                    <VzmPrint label={InputMap.loadCapa.label} value={`${item.loadCapa} (${item.loadCapaText})`} marginBottom={8} />
                    <VzmPrint label={InputMap.minLoad.label} value={item.minLoad} marginBottom={8} />
                    <VzmPrint label={InputMap.rentType.label} value={RentTypes[item.rentType]}  />
                </ViewContainer>
            </DialogContent>
            <DialogActions>
                {
                    canEdit ?
                    <Button
                        onClick={()=>{onRequestEdit(item)}}
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.inherit}
                        sx={{width: 120, marginRight: 1}}
                        startIcon={<EditIcon />}
                    >
                        편집
                    </Button>
                    : null
                }
                <Button onClick={onClose}
                    variant={AppStyle.mui.contained}
                    color={AppStyle.mui.primary}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );
}
